/* FN · Cart. Drives the cart drawer and the cart page (snippets/fn-cart-body.liquid).
   - Every change goes through the Ajax Cart API and comes back as freshly rendered sections,
     so prices, discounts and free shipping always match what checkout will show.
   - Requests are queued so fast taps never race each other.
   - Keeps the old <cart-drawer> API (getSectionsToRender, renderContents, setActiveElement)
     so product forms, quick add and FN add buttons keep working unchanged. */
(function () {
  if (window.__fnCart) return;
  window.__fnCart = true;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var ERR = 'Sorry, we couldn’t update your cart. Please try again.';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function ev(name) { try { return typeof PUB_SUB_EVENTS !== 'undefined' ? PUB_SUB_EVENTS[name] : null; } catch (e) { return null; } }
  function pub(name, data) { try { var n = ev(name); if (n && typeof publish === 'function') publish(n, data); } catch (e) {} }
  function parse(html) { return new DOMParser().parseFromString(html, 'text/html'); }

  /* fn-cart.css positions the panel; without it the panel is a plain static block */
  function styled(panel) { return !!panel && window.getComputedStyle(panel).position !== 'static'; }

  function updateBubble(sections) {
    var html = sections && sections['cart-icon-bubble'];
    var el = document.getElementById('cart-icon-bubble');
    if (!html || !el) return;
    var src = parse(html).querySelector('.shopify-section');
    if (src) el.innerHTML = src.innerHTML;
  }

  /* ---------- one cart surface (drawer panel or page section) ---------- */
  function Cart(el, host) {
    this.el = el;
    this.host = host || null;
    this.mode = el.getAttribute('data-fnk-mode');
    this.queue = Promise.resolve();
    this.timers = {};
    this.pending = 0;
    this.bind();
    this.watchBar();
  }

  /* cart page on phones: show a sticky checkout bar while the real button is off screen */
  Cart.prototype.watchBar = function () {
    if (this.mode !== 'page' || !('IntersectionObserver' in window)) return;
    var bar = this.el.querySelector('[data-fnk-mbar]');
    var go = this.el.querySelector('[data-fnk-checkout]');
    if (this.io) this.io.disconnect();
    if (!bar || !go) return;
    var shown = false;
    this.io = new IntersectionObserver(function (en) {
      var e = en[0];
      // show it while the summary's checkout button is still below the screen; hide it once that button is visible or scrolled past
      var on = !e.isIntersecting && e.boundingClientRect.top > 0;
      if (on !== shown) { shown = on; bar.classList.toggle('is-on', on); bar.setAttribute('aria-hidden', on ? 'false' : 'true'); bar.tabIndex = on ? 0 : -1; }
    });
    this.io.observe(go);
  };

  Cart.prototype.sections = function () {
    return (this.el.getAttribute('data-fnk-sections') || '').split(',').filter(Boolean);
  };

  Cart.prototype.bind = function () {
    var self = this;
    this.el.addEventListener('click', function (e) {
      var t = e.target.closest('[data-fnk-step],[data-fnk-remove],[data-fnk-plan],[data-fnk-add],[data-fnk-suball]');
      if (!t || !self.el.contains(t)) return;
      var line = t.closest('[data-fnk-line]');
      if (t.hasAttribute('data-fnk-step')) {
        var input = line.querySelector('[data-fnk-input]');
        var next = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(t.getAttribute('data-fnk-step'), 10));
        input.value = next;
        self.qtyLater(line, next);
      } else if (t.hasAttribute('data-fnk-remove')) {
        self.remove(line);
      } else if (t.hasAttribute('data-fnk-plan')) {
        self.plan(line, t);
      } else if (t.hasAttribute('data-fnk-add')) {
        self.add(t);
      } else if (t.hasAttribute('data-fnk-suball')) {
        self.subAll(t);
      }
    });
    this.el.addEventListener('change', function (e) {
      if (e.target.matches('[data-fnk-input]')) {
        var line = e.target.closest('[data-fnk-line]');
        var v = parseInt(e.target.value, 10);
        if (isNaN(v) || v < 0) v = 0;
        self.qtyLater(line, v, 0);
      } else if (e.target.matches('[data-fnk-note]')) {
        self.run({ url: 'cart/update.js', body: { note: e.target.value }, quiet: true });
      }
    });
    this.el.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && e.target.matches('[data-fnk-input]')) { e.preventDefault(); e.target.blur(); }
    });
    this.el.addEventListener('submit', function (e) {
      // never send people to checkout with a change still in flight
      if (self.pending > 0) { e.preventDefault(); self.queue.then(function () { self.el.querySelector('[data-fnk-checkout]').click(); }); }
    });
  };

  /* ---------- actions ---------- */
  Cart.prototype.qtyLater = function (line, qty, wait) {
    var self = this;
    var key = line.getAttribute('data-key');
    clearTimeout(this.timers[key]);
    line.classList.add('is-dirty');
    this.timers[key] = setTimeout(function () {
      delete self.timers[key];
      if (String(qty) === line.getAttribute('data-qty')) { line.classList.remove('is-dirty'); return; }
      if (qty === 0) return self.remove(line);
      self.run({ url: 'cart/change.js', body: { id: key, quantity: qty }, line: line });
    }, wait === 0 ? 0 : 320);
  };

  Cart.prototype.remove = function (line) {
    var key = line.getAttribute('data-key');
    clearTimeout(this.timers[key]);
    if (!reduce) { line.style.height = line.offsetHeight + 'px'; line.offsetHeight; }
    line.classList.add('is-leaving');
    var name = (line.querySelector('.fnk-line__title') || {}).textContent || 'Item';
    this.run({ url: 'cart/change.js', body: { id: key, quantity: 0 }, line: line, say: name.trim() + ' removed from your cart.' });
  };

  Cart.prototype.plan = function (line, btn) {
    var on = btn.getAttribute('aria-checked') === 'true';
    btn.setAttribute('aria-checked', on ? 'false' : 'true');
    btn.classList.toggle('is-on', !on);
    var id = btn.getAttribute('data-fnk-plan');
    this.run({
      url: 'cart/change.js',
      body: { id: line.getAttribute('data-key'), quantity: parseInt(line.getAttribute('data-qty'), 10) || 1, selling_plan: on ? null : Number(id) },
      line: line,
      focusIndex: indexOf(this.el, line, '[data-fnk-plan]'),
      say: on ? 'Switched to a one-time purchase.' : 'Switched to Subscribe & save.'
    });
  };

  Cart.prototype.subAll = function (btn) {
    var self = this;
    var jobs = Array.prototype.slice.call(this.el.querySelectorAll('[data-fnk-plan]:not(.is-on)'));
    if (!jobs.length) return;
    btn.disabled = true;
    jobs.forEach(function (b) { b.classList.add('is-on'); b.setAttribute('aria-checked', 'true'); });
    var last = jobs.length - 1;
    jobs.forEach(function (b, i) {
      var line = b.closest('[data-fnk-line]');
      self.run({
        url: 'cart/change.js',
        body: { id: line.getAttribute('data-key'), quantity: parseInt(line.getAttribute('data-qty'), 10) || 1, selling_plan: Number(b.getAttribute('data-fnk-plan')) },
        line: line,
        skipRender: i !== last,
        say: i === last ? 'Everything is now on Subscribe & save.' : ''
      });
    });
  };

  Cart.prototype.add = function (btn) {
    var self = this;
    btn.disabled = true;
    btn.classList.add('is-busy');
    this.run({
      url: 'cart/add.js',
      body: { items: [{ id: Number(btn.getAttribute('data-fnk-add')), quantity: 1 }] },
      say: 'Added to your cart.',
      after: function () {
        var sc = self.el.querySelector('[data-fnk-scroll]');
        if (sc) sc.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
      },
      fail: function () { btn.disabled = false; btn.classList.remove('is-busy'); }
    });
  };

  /* ---------- request queue ---------- */
  Cart.prototype.run = function (job) {
    var self = this;
    this.pending++;
    this.busy(true);
    if (job.line) job.line.classList.add('is-busy');
    var body = Object.assign({}, job.body);
    if (!job.skipRender) {
      body.sections = this.sections().join(',');
      body.sections_url = window.location.pathname;
    }
    this.queue = this.queue.then(function () {
      return fetch(ROOT + job.url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(body)
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok || res.j.status) throw new Error(res.j.description || res.j.message || ERR);
          if (job.quiet || job.skipRender) return;
          self.render(res.j.sections, job);
          if (job.url === 'cart/add.js' && (!res.j.sections || self.el.querySelector('.fnk--empty'))) self.refresh();
          pub('cartUpdate', { source: 'fn-cart', cartData: res.j });
          if (job.after) job.after();
        })
        .catch(function (err) {
          if (job.fail) job.fail();
          self.refresh().then(function () { self.error(err && err.message && err.message !== 'Failed to fetch' ? err.message : ERR); });
          pub('cartError', { source: 'fn-cart', errors: err && err.message });
        })
        .then(function () {
          self.pending--;
          if (self.pending <= 0) { self.pending = 0; self.busy(false); }
        });
    });
    return this.queue;
  };

  Cart.prototype.busy = function (on) {
    this.el.classList.toggle('is-busy', on);
    var go = this.el.querySelector('[data-fnk-checkout]');
    if (go) go.setAttribute('aria-disabled', on ? 'true' : 'false');
  };

  Cart.prototype.error = function (msg) {
    var box = this.el.querySelector('[data-fnk-error]');
    if (!box) return;
    box.textContent = msg;
    box.hidden = false;
    clearTimeout(this.errT);
    this.errT = setTimeout(function () { box.hidden = true; }, 6000);
  };

  Cart.prototype.refresh = function () {
    var self = this;
    var url = (this.mode === 'page' ? window.location.pathname : ROOT) + '?sections=' + this.sections().join(',');
    return fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (s) { self.render(s, {}); })
      .catch(function () {});
  };

  /* ---------- render ---------- */
  Cart.prototype.render = function (sections, job) {
    if (!sections) return;
    job = job || {};
    var html = sections[this.sections()[0]];
    if (html) {
      var doc = parse(html);
      var src = doc.getElementById(this.el.id);
      if (src) this.swap(src, job);
    }
    updateBubble(sections);
    if (this.host) this.host.syncCount();
  };

  Cart.prototype.swap = function (src, job) {
    var el = this.el;
    var oldScroll = el.querySelector('[data-fnk-scroll]');
    var scrollTop = oldScroll ? oldScroll.scrollTop : 0;
    var oldFill = el.querySelector('[data-fnk-ship-fill]');
    var fromW = oldFill ? oldFill.style.width : null;
    var active = document.activeElement;
    var focusSel = job.focus || null;
    if (!focusSel && active && el.contains(active)) {
      var l = active.closest('[data-fnk-line]');
      if (l && active.matches('[data-fnk-step],[data-fnk-input]')) focusSel = focusKey(l, active.matches('[data-fnk-input]') ? '[data-fnk-input]' : '[data-fnk-step="' + active.getAttribute('data-fnk-step') + '"]');
    }
    // keep live express checkout buttons instead of re-creating them
    var keep = {};
    el.querySelectorAll('[data-fnk-keep]').forEach(function (k) { keep[k.getAttribute('data-fnk-keep')] = k; });

    el.innerHTML = src.innerHTML;

    var needInit = false;
    el.querySelectorAll('[data-fnk-keep]').forEach(function (k) {
      var old = keep[k.getAttribute('data-fnk-keep')];
      if (old) k.replaceWith(old); else needInit = true;
    });
    if (needInit && window.Shopify && window.Shopify.PaymentButton && typeof window.Shopify.PaymentButton.init === 'function') {
      try { window.Shopify.PaymentButton.init(); } catch (e) {}
    }

    var sc = el.querySelector('[data-fnk-scroll]');
    if (sc) sc.scrollTop = scrollTop;

    var fill = el.querySelector('[data-fnk-ship-fill]');
    if (fill && fromW && !reduce) {
      var to = fill.style.width;
      fill.style.transition = 'none';
      fill.style.width = fromW;
      fill.offsetWidth;
      fill.style.transition = '';
      requestAnimationFrame(function () { fill.style.width = to; });
    }

    var target = null;
    if (focusSel) target = el.querySelector(focusSel);
    if (!target && typeof job.focusIndex === 'number' && job.focusIndex > -1) target = el.querySelectorAll('[data-fnk-plan]')[job.focusIndex];
    var lost = !document.activeElement || document.activeElement === document.body;
    if (!target && lost && this.mode === 'drawer' && this.host && this.host.isOpen) target = el.querySelector('[data-fnk-close]');
    if (target) { try { target.focus({ preventScroll: true }); } catch (e) {} }

    this.watchBar();

    if (job.say) {
      var live = el.querySelector('[data-fnk-live]');
      if (live) live.textContent = job.say;
    }
  };

  function focusKey(line, inner) {
    var k = line.getAttribute('data-key');
    return '[data-fnk-line][data-key="' + (window.CSS && CSS.escape ? CSS.escape(k) : k) + '"] ' + inner;
  }
  function indexOf(root, line, sel) {
    var all = Array.prototype.slice.call(root.querySelectorAll(sel));
    return all.indexOf(line.querySelector(sel));
  }

  /* ---------- the drawer element ---------- */
  if (!customElements.get('cart-drawer')) {
    customElements.define('cart-drawer', class extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        this._ready = true;
        this.cartType = this.dataset.cartType;
        this.panel = this.querySelector('#CartDrawer');
        this.isOpen = false;
        this.cart = new Cart(this.panel, this);
        var self = this;
        this.addEventListener('click', function (e) { if (e.target.closest('[data-fnk-close]')) { e.preventDefault(); self.close(); } });
        this.addEventListener('keydown', function (e) { self.onKey(e); });
        document.addEventListener('cart-drawer:refresh', function () { self.cart.refresh(); });
      }
      onKey(e) {
        if (!this.isOpen) return;
        if (e.key === 'Escape') { e.preventDefault(); this.close(); return; }
        if (e.key !== 'Tab') return;
        var f = Array.prototype.filter.call(this.panel.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),textarea,select,iframe,[tabindex]:not([tabindex="-1"])'), function (n) { return n.offsetParent !== null || n === document.activeElement; });
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && (document.activeElement === first || document.activeElement === this.panel)) { last.focus(); e.preventDefault(); }
        else if (!e.shiftKey && document.activeElement === last) { first.focus(); e.preventDefault(); }
      }
      /* On a slow first visit the cart styles can still be downloading. Opening then would show the
         drawer unstyled (see-through, giant images), so wait for them; if they never arrive, go to /cart. */
      open(opener) {
        if (this.isOpen || this._waiting) return;
        if (styled(this.panel)) return this.show(opener);
        var self = this;
        var t0 = Date.now();
        this._waiting = true;
        document.documentElement.classList.add('fnk-wait');
        var link = document.getElementById('FnkCss');
        if (link && link.rel !== 'stylesheet') link.rel = 'stylesheet';
        (function poll() {
          if (styled(self.panel)) { done(); self.show(opener); }
          else if (Date.now() - t0 > 6000) { done(); window.location.href = (window.routes && window.routes.cart_url) || ROOT + 'cart'; }
          else setTimeout(poll, 40);
        })();
        function done() { self._waiting = false; document.documentElement.classList.remove('fnk-wait'); }
      }
      show(opener) {
        if (this.isOpen) return;
        this.isOpen = true;
        this.returnTo = opener || this.activeElement || document.activeElement;
        var gap = window.innerWidth - document.documentElement.clientWidth;
        document.documentElement.style.setProperty('--fnk-gap', gap + 'px');
        document.documentElement.classList.add('fnk-locked');
        this.panel.removeAttribute('inert');
        this.classList.add('is-open');
        var close = this.panel.querySelector('[data-fnk-close]');
        requestAnimationFrame(function () { if (close) close.focus({ preventScroll: true }); });
        this.syncCount();
        document.dispatchEvent(new CustomEvent(ev('cartDrawerOpen') || 'cart-drawer-open', { bubbles: true }));
        pub('cartDrawerOpen', { source: 'fn-cart' });
      }
      close() {
        if (!this.isOpen) return;
        this.isOpen = false;
        this.classList.remove('is-open');
        this.panel.setAttribute('inert', '');
        document.documentElement.classList.remove('fnk-locked');
        var r = this.returnTo;
        this.returnTo = null;
        if (r && r.focus && document.contains(r)) { try { r.focus({ preventScroll: true }); } catch (e) {} }
        document.dispatchEvent(new CustomEvent(ev('cartDrawerClose') || 'cart-drawer-close', { bubbles: true }));
        pub('cartDrawerClose', { source: 'fn-cart' });
      }
      toggle() { this.isOpen ? this.close() : this.open(); }
      syncCount() {
        var c = this.panel.querySelector('.fnk-count');
        var trigger = document.getElementById('cart-icon-bubble');
        if (trigger) trigger.setAttribute('aria-label', 'Cart, ' + (c ? c.textContent.trim() : '0') + ' items');
      }
      /* ---- API used by product-form.js, fn-pdp.js, fn-home.js, fn-collection.js ---- */
      getSectionsToRender() { return [{ id: 'cart-drawer', selector: '#CartDrawer' }, { id: 'cart-icon-bubble' }]; }
      getSectionInnerHTML(html, selector) { var n = parse(html).querySelector(selector || '.shopify-section'); return n ? n.innerHTML : ''; }
      renderContents(parsedState, isClosedCart) {
        var s = parsedState && parsedState.sections;
        if (s) this.cart.render(s, {});
        /* Something was just added but the drawer came back empty or without sections: fetch it fresh. */
        var added = parsedState && !parsedState.status && (Array.isArray(parsedState.items) ? parsedState.items.length > 0 : !!(parsedState.variant_id || parsedState.id));
        if (added && (!s || this.panel.querySelector('.fnk--empty'))) this.cart.refresh();
        if (isClosedCart !== false) this.open();
      }
      setActiveElement(el) { this.activeElement = el; }
      refreshCartDrawer() { return this.cart.refresh(); }
    });
  }

  function drawer() {
    var d = document.querySelector('cart-drawer.fnk-drawer');
    return d && d.cartType !== 'page' && typeof d.open === 'function' ? d : null;
  }

  /* header cart icon and any [data-fnk-open] link open the drawer instead of loading /cart */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('.wt-cart__trigger, [data-fnk-open]');
    if (!t || e.metaKey || e.ctrlKey || e.shiftKey || e.button > 0) return;
    var d = drawer();
    if (!d) return;
    e.preventDefault();
    d.toggle();
  });

  /* back/forward cache can show a stale cart: refresh it */
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    var d = drawer();
    if (d) d.cart.refresh();
    document.querySelectorAll('[data-fnk-root][data-fnk-mode="page"]').forEach(function (el) { if (el.__fnk) el.__fnk.refresh(); });
  });

  /* cart page */
  function initPages() {
    document.querySelectorAll('[data-fnk-root][data-fnk-mode="page"]').forEach(function (el) {
      if (!el.__fnk) el.__fnk = new Cart(el, null);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initPages); else initPages();
  document.addEventListener('shopify:section:load', initPages);

  /* other scripts can ask for a refresh */
  document.addEventListener('fn-cart:refresh', function () {
    var d = drawer();
    if (d) d.cart.refresh();
    document.querySelectorAll('[data-fnk-root][data-fnk-mode="page"]').forEach(function (el) { if (el.__fnk) el.__fnk.refresh(); });
  });
})();
